import React from "react";
import "./CorporateTrip.css";
import GoaTeamBuildingRetreat from "../../assets/GoaTeamBuildingRetreat.png";
import RishikeshLeadershipCamp from "../../assets/RishikeshLeadershipCamp.png";
import LonavalaConferenceEscape from "../../assets/LonavalaConferenceEscape.png";
import JaipurBusinessNetworkingTour from "../../assets/JaipurBusinessNetworkingTour.png";
import KeralaBackwaterStrategyRetreat from "../../assets/KeralaBackwaterStrategyRetreat.png";
import ManaliCorporateAdventureMeet from "../../assets/ManaliCorporateAdventureMeet.png";
import { useNavigate } from "react-router-dom";
const corporateTrips = [
  {
    title: "Goa Team Building Retreat",
    image: GoaTeamBuildingRetreat,
    description:
      "Strengthen teamwork and collaboration with engaging activities on Goa beautiful beaches. Enjoy leadership workshops, group challenges, relaxing evenings, and professional networking opportunities in this refreshing corporate retreat designed for productivity and bonding.",
    link: "/tour-package-data",
  },
  {
    title: "Rishikesh Leadership Camp",
    image: RishikeshLeadershipCamp,
    description:
      "Enhance leadership skills through adventure activities and strategy sessions in Rishikesh serene surroundings. Experience rafting, outdoor workshops, motivational seminars, and team building exercises during this impactful corporate development retreat.",
    link: "/tour-package-data",
  },
  {
    title: "Lonavala Conference Escape",
    image: LonavalaConferenceEscape,
    description:
      "Combine business meetings with scenic relaxation in Lonavala peaceful hills. Enjoy modern conference facilities, interactive team sessions, networking events, and comfortable accommodations in this balanced corporate getaway.",
    link: "/tour-package-data",
  },
  {
    title: "Jaipur Business Networking Tour",
    image: JaipurBusinessNetworkingTour,
    description:
      "Host professional meetings and networking events in Jaipur royal ambiance. Explore heritage venues, team workshops, cultural evenings, and collaborative sessions while strengthening business relationships during this productive corporate trip.",
    link: "/tour-package-data",
  },
  {
    title: "Kerala Backwater Strategy Retreat",
    image: KeralaBackwaterStrategyRetreat,
    description:
      "Plan strategic discussions and brainstorming sessions amidst Kerala tranquil backwaters. Enjoy houseboat stays, team bonding activities, leadership workshops, and peaceful natural surroundings in this inspiring corporate retreat experience.",
    link: "/tour-package-data",
  },
  {
    title: "Manali Corporate Adventure Meet",
    image: ManaliCorporateAdventureMeet,
    description:
      "Boost morale and productivity with adventure based team activities in Manali scenic mountains. Enjoy workshops, trekking sessions, group discussions, and relaxing evenings in this energizing corporate getaway designed for growth.",
    link: "/tour-package-data",
  },
];

const CorporateTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="corporate-container">
      <h2 className="corporate-title">Corporate Trip Packages</h2>

      <div className="corporate-grid">
        {corporateTrips.map((trip, index) => (
          <div
            className="corporate-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="corporate-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CorporateTrip;
